import { useState, useEffect } from 'react';
import { Network } from '@capacitor/network';
import { platform } from '@/lib/platform';

export function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    if (platform.isNative) {
      // Use native network plugin for more reliable detection
      Network.getStatus().then(status => setIsOffline(!status.connected));
      const listener = Network.addListener('networkStatusChange', (status) => {
        setIsOffline(!status.connected);
      });
      return () => { listener.then(l => l.remove()); };
    } else {
      // Fallback to browser events
      const handleOnline = () => setIsOffline(false);
      const handleOffline = () => setIsOffline(true);
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);
      return () => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
      };
    }
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white text-center text-sm py-1 px-4"
         style={{ paddingTop: 'calc(var(--safe-area-top, 0px) + 4px)' }}>
      You're offline. Some data may not be current.
    </div>
  );
}
